/* eslint-disable quotes */
import { h } from 'vue';
import { vimeo } from '../../vimeo';

const body = `<h4>Delete objects</h4>

<p>Delete selected objects.</p>

<div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="${vimeo('566295116')}" loading="lazy"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
</div>

<ul class='shortcuts'>
    <li class='shortcuts__item'><b>Shortcuts:</b></li>
    <li class='shortcuts__item'><b>Del</b> or <b>Backspace</b>: Delete objects.</li>
    <li class='shortcuts__item'><b>Shift-Del</b> or <b>Shift-Backspace</b>: Delete selected edge(s) along with any floating vertices left</li>
    <li class='shortcuts__item'><b>2</b>: Delete non-fixed vertices with 2 edges only</li>
    <li class='shortcuts__item'><b>Shift-2</b>: As in "2", but keep the edge shape as is</li>
</ul>`;

export default function DeleteObjectsTooltip() {
    return h('div', { innerHTML: body });
}
